import { writable } from 'svelte/store';
export const stateStore = writable({
    isPopupVisible: false,
    isPopupClosed: false,
});
